module.exports = __webpack_public_path__ + "static/media/agora.04c5d6bd.png";